import { 
  getFirestore, 
  collection, 
  doc, 
  getDocs, 
  getDoc,
  addDoc, 
  updateDoc, 
  deleteDoc,
  query,
  where,
  orderBy,
  limit,
  CollectionReference,
  Query,
  DocumentData
} from 'firebase/firestore';
import firebaseApp from './firebase';

// Initialize Firestore
const db = getFirestore(firebaseApp);

// Generic get collection data
export const getCollection = async (collectionName: string) => {
  const querySnapshot = await getDocs(collection(db, collectionName));
  return querySnapshot.docs.map(doc => ({
    id: doc.id,
    ...doc.data()
  }));
};

// Get document by ID
export const getDocument = async (collectionName: string, docId: string) => {
  const docRef = doc(db, collectionName, docId);
  const docSnap = await getDoc(docRef);
  
  if (docSnap.exists()) {
    return {
      id: docSnap.id,
      ...docSnap.data()
    };
  } else {
    return null;
  }
};

// Add document to collection
export const addDocument = async (collectionName: string, data: any) => {
  return await addDoc(collection(db, collectionName), data);
};

// Update document
export const updateDocument = async (collectionName: string, docId: string, data: any) => {
  const docRef = doc(db, collectionName, docId);
  return await updateDoc(docRef, data);
};

// Delete document
export const deleteDocument = async (collectionName: string, docId: string) => {
  const docRef = doc(db, collectionName, docId);
  return await deleteDoc(docRef);
};

// Query collection with filters
export const queryCollection = async (
  collectionName: string, 
  filters: Array<{ field: string, operator: string, value: any }>,
  sortBy?: { field: string, direction: 'asc' | 'desc' },
  limitTo?: number
) => {
  let collectionRef = collection(db, collectionName);
  let q: Query<DocumentData> = collectionRef;
  
  // Add filters
  if (filters.length > 0) {
    q = query(
      collectionRef, 
      ...filters.map(filter => 
        where(filter.field, filter.operator as any, filter.value)
      )
    );
  }
  
  // Add sorting
  if (sortBy) {
    q = query(q, orderBy(sortBy.field, sortBy.direction));
  }
  
  // Add limit
  if (limitTo) {
    q = query(q, limit(limitTo));
  }
  
  const querySnapshot = await getDocs(q);
  return querySnapshot.docs.map(doc => ({
    id: doc.id,
    ...doc.data()
  }));
};

export default db; 